// @ts-nocheck

import * as R from 'ramda';
import * as React from 'react';
import AuthInput from './AuthInput';
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input
const VALID_INPUT_PROPS = ['name', 'type', 'autoComplete'];
type Props = {
  /**
   * label is what will appear as the title.
   * If no label is passed in Title will render null.
   */
  label?: string | null | undefined;

  /**
   * callback to parent on input text change
   * required in all scenarios EXCEPT when the input field is always disabled
   * and therefore cannot change
   */
  onChange?: (event: {
    target: {
      value: string;
    };
    value: string | null | undefined;
    error: boolean | null | undefined;
  }) => void;

  /**
   * required id for automation testing
   */
  testid: string;

  /**
   * The value of the input field
   */
  value?: string | null | undefined;

  /**
   * Component to replace the input tag
   */
  // customChildComponent?: React.Element<any>,

  /**
   * Append classes to input container
   */
  // className?: string,

  /**
   * Additonal note to display below the input field ('description' goes above)
   * Please see renderFootnote for further clarification.
   */
  footnote?: string | React.ReactElement<any>;

  /**
   * This prop is passed down from the ScreenSignup component
   * and triggers the render of the green check icon once a password
   * has passed all 5 validation checks.
   */
  inputValid?: boolean;

  /**
   * This prop is passed down from the ScreenSignup component
   * and helps to determine when to render the success or fail icon in the password input.
   * No icon will be rendered until we know the validation has occured.
   */
  inputChecked?: boolean;

  /**
   * This prop is passed down from the ScrenSignup component and applies red border styling on the
   * input field if there is an error with the input.
   */
  hasError?: boolean;

  /**
   * This is to disable copying from the password input field.
   */
  pasteDisabled?: boolean;

  /**
   * This is to display the Show/Hide icon next to the title
   */
  displayShowHide?: boolean;
};
type State = {
  showPassword: boolean | null | undefined;
  passwordValid: boolean | null | undefined;
  passwordChecked: boolean | null | undefined;
  passwordsMatch: boolean | null | undefined;
  passwordsMatchChecked: boolean | null | undefined;
};

class PasswordInput extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showPassword: false,
      passwordValid: false,
      passwordChecked: false,
      passwordsMatch: false,
      passwordsMatchChecked: false,
    };
  }

  // This toggles the show/hide feature for password input field.
  _onShowHide = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  render() {
    const { label, onChange, value, testid, hasError, footnote, inputValid, inputChecked, pasteDisabled, displayShowHide } =
      this.props;
    return (
      <div className="password-input">
        <AuthInput
          {...R.pick(VALID_INPUT_PROPS, this.props)}
          label={label}
          onChange={onChange}
          value={value}
          testid={testid}
          hasError={hasError}
          footnote={footnote}
          type={this.state.showPassword ? 'text' : 'password'}
          inputChecked={inputChecked}
          inputValid={inputValid}
          pasteDisabled={pasteDisabled}
          displayShowHide={displayShowHide}
          onShowHide={this._onShowHide}
        />
      </div>
    );
  }
}

export default PasswordInput;
